<template>
    <div class="news-list">
        <BasePage mode="list">
            <div slot="searchBar">
                <div class="search-box">
                    <div class="search-item">
                            <el-date-picker
                            v-model="timeArray"
                                type="daterange"
                                placeholder="选择日期"
                                range-separator="至"
                                start-placeholder="支出时间起"
                                end-placeholder="支出时间止"
                                value-format="timestamp"
                                @change="changeTime"
                            />
                    </div>
                    <div class="search-item">
                        <el-select
                            v-model="queryParam.isPublicity"
                            placeholder="公示状态"
                            clearable
                            @change="onSelect"
                            >
                            <el-option
                                v-for="item in stateOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-item">
                        <OfSearch
                            @search="searchVal"
                            placeholder="请输入关键字"
                            :showbutton="true"
                        ></OfSearch>
                    </div>

                </div>

            </div>
            <div>
                <el-tabs
                    v-model="activeName"
                    type="border-card"
                    @tab-click="handleTabsClick"
                >
                  <el-tab-pane label="资金支出" name="donation">
                    <donation ref="donation" :queryParam="queryParam"></donation>
                  </el-tab-pane>
                  <el-tab-pane label=物品支出 name="materials">
                    <materials ref="materials" :queryParam="queryParam"></materials>
                  </el-tab-pane>
                </el-tabs>
            </div>
        </BasePage>
    </div>
</template>
<script>
import Donation from './components/donation.vue'
import Materials from './components/materials.vue'
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import api from "@/modules/zjrc/api";
export default {
    components: {
        BasePage,
        OfSearch,
        Donation,
        Materials
    },
    data() {
        return {
            headerRow: "header-row",
            queryParam: {
                pageIndex: 1,
                pageSize: 15,
                startTime: null,
                endTime: null,
                expendType: 1,
                searchKey: '',
                isPublicity: undefined
            },
            list: [],
            activeName: 'donation',
            timeArray: [],
            stateOptions: [
                {
                    label: '是',
                    value: true
                },
                {
                    label: '否',
                    value: false
                }
            ]
        }
    },
    mounted() {
        const vm = this
        if (vm.$route.query && vm.$route.query.activeName) {
            vm.activeName = vm.$route.query.activeName
            vm.search()
        } else {
            vm.activeName = 'donation'
            vm.queryParam.expendType = 1
            vm.$nextTick(() => {
                vm.$refs.donation.reloadData()
            })
        }
    },
    methods: {
        onSelect(val) {
            const vm = this
            if (val === '') {
                vm.queryParam.isPublicity = undefined
            } else {
                vm.queryParam.isPublicity = val
            }
            vm.search()
        },
        changeTime(val) {
            const vm = this
            if (val === null) {
                vm.queryParam.startTime = null
                vm.queryParam.endTime = null
            }else {
                vm.queryParam.startTime = val[0] / 1000
                vm.queryParam.endTime = val[1] / 1000
            }
            vm.search()
        },
        searchVal(val) {
            const vm = this
            vm.queryParam.searchKey = val
            vm.search()
        },
        handleTabsClick(tab) {
            const vm = this
            vm.activeName = tab.name
            vm.timeArray = []
            vm.queryParam.startTime = null
            vm.queryParam.endTime = null
            vm.queryParam.isPublicity = undefined
            switch(tab.name) {
                case 'donation':
                    vm.queryParam.expendType = 1
                    vm.$nextTick(()=> {
                        vm.$refs.donation.reloadData()
                    })
                    break
                case 'materials':
                    vm.queryParam.expendType = 2
                    vm.$nextTick(()=> {
                        vm.$refs.materials.reloadData()
                    })
                    break
            }
        },
        search () {
            const vm = this
            switch (vm.activeName) {
                case 'donation':
                    vm.queryParam.expendType = 1
                    vm.$nextTick(() => {
                        vm.$refs.donation.reloadData()
                    })
                    break
                case 'materials':
                    vm.queryParam.expendType = 2
                    vm.$nextTick(() => {
                        vm.$refs.materials.reloadData()
                    })
                    break
            }
        },
    }
}
</script>
<style scoped lang="scss">
.search-box {
    display: flex;
    align-items: center;

    .search-item {
        line-height:1;
        margin-right: 5px;
    }
}
/deep/ .el-date-editor .el-range__icon {
    line-height: 0;
}
/deep/ .el-date-editor .el-range-separator {
    line-height: 1.5;
    padding: 0;
}
/deep/ .el-date-editor .el-range__close-icon {
    line-height: 1.5;
}
</style>